export default __webpack_public_path__ + "static/bt_open_house_2-73df187677d273eeb3f56e64b5208bd1.jpg";